'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Trans } from 'react-i18next/TransWithoutContext';
import utilities from '@/helpers/utilities';
import logo from '@/public/logo-with-text.svg';
import teaserEN from '@/public/teaser-en.svg';
// todo need DE-Image
import teaserDE from '@/public/teaser-en.svg';
import { Button } from '../components/_catalyst/button';
import { useTranslation } from '../i18n/client';
export default function Home(t0) {
  const $ = _c(64);
  const {
    lng
  } = t0;
  const {
    t
  } = useTranslation(lng, "home");
  const router = useRouter();
  let t1;
  if ($[0] !== t) {
    t1 = t("label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-4xl font-bold">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("subLabel");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="text-2xl font-bold">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = lng === "de" ? teaserDE : teaserEN;
  let t6;
  if ($[8] !== t5) {
    t6 = <Image src={t5} alt="Logo of docomondo" height={450} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className="flex flex-col items-center justify-center text-center text-white">{t2}{t4}{t6}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute -right-16 h-full w-24"><svg className="fill-cPrimary-100 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0 0 Q 50 50 0 100 L 100 100 L 100 0 Z" /></svg></div>;
    t9 = <div className="h-44 w-full" />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7) {
    t10 = <div className="bg-cPrimary relative flex w-6/12 flex-1 flex-col items-center justify-center">{t7}{t8}{t9}</div>;
    $[16] = t7;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex w-full flex-row items-center justify-end p-4"><Image src={logo} alt="Logo of docomondo" height={35} /></div>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== lng) {
    t12 = utilities.classNames("mr-2 ml-2", lng === "de" ? "text-cPrimary underline" : "text-gray-400");
    $[19] = lng;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <a className={t12} href="/de">{"de"}</a>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== lng) {
    t14 = utilities.classNames("mr-2 ml-2", lng === "en" ? "text-cPrimary underline" : "text-gray-400");
    $[23] = lng;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14) {
    t15 = <a className={t14} href="/en">{"en"}</a>;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t15) {
    t16 = <div className="mb-4 flex flex-row gap-2">{t13}{t15}</div>;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <a className="text-cPrimary hover:underline" href="https://docomondo.com" target="_blank" rel="noreferrer">docomondo!</a>;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t) {
    t18 = <div className="flex flex-col items-center justify-center text-center"><p className="mb-4 text-5xl no-underline"><Trans i18nKey="welcomeTo" t={t}>Welcome to{t17}</Trans></p></div>;
    $[31] = t;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== router) {
    t19 = () => router.push("/sign-in");
    $[33] = router;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = t("login");
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <Button className="w-full" onClick={t19}>{t20}</Button>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== router) {
    t22 = () => router.push("/sign-up");
    $[40] = router;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t) {
    t23 = t("signUp");
    $[42] = t;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t22 || $[45] !== t23) {
    t24 = <Button className="w-full" outline={true} onClick={t22}>{t23}</Button>;
    $[44] = t22;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t21 || $[48] !== t24) {
    t25 = <div className="flex flex-col items-center gap-2">{t21}{t24}</div>;
    $[47] = t21;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t16 || $[51] !== t18 || $[52] !== t25) {
    t26 = <div className="flex flex-1 flex-col items-center justify-center">{t16}{t18}{t25}</div>;
    $[50] = t16;
    $[51] = t18;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div />;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t26) {
    t28 = <div className="flex min-h-screen flex-1 flex-col items-center justify-between">{t11}{t26}{t27}</div>;
    $[55] = t26;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t10 || $[58] !== t28) {
    t29 = <div className="bg-cPrimary-100 flex flex-1 flex-row">{t10}{t28}</div>;
    $[57] = t10;
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <p>Powered by Docomondo</p>;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <footer className="border-t-cWhiteSmoke flex flex-1 items-center justify-center border-t border-solid px-0 py-8">{t30}<div className="ml-2"><Image src={logo} alt="Logo of docomondo" width={35} height={35} style={{
          maxWidth: "100%",
          height: "auto"
        }} /></div></footer>;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t29) {
    t32 = <div>{t29}{t31}</div>;
    $[62] = t29;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  return t32;
}